import React from 'react';
import * as FPT from '../utility/fpt';
import { CaptionText, BodyText } from '@paypalcorp/pp-react';
import getSocialCampaign from '../utility/getSocialCampaign';
import TemplateData, { localsMessages } from '../utility/getTemplateData';
import SocialShare from '../components/socialShare/socialShare';

const { label: copyLinkMessages } = localsMessages('common/copyLink');
const { title = {} } = localsMessages('common/socialShareMessage');

export default function ConfirmationSocialShare(props) {
  const {
    hostedButtonId,
    orgName,
    messages: { social },
  } = props;
  const { copy, copied } = copyLinkMessages;

  const handleSocialAnalytics = (type) => {
    FPT.trackLinkClick(type);
  };

  const socialMessages = {
    ...social,
    copyLinkCopy: copy,
    copyLinkCopied: copied,
  };

  const socialCampaign = getSocialCampaign(
    socialMessages,
    orgName,
    hostedButtonId,
    title
  );

  return (
    <>
      <BodyText className="text-center social_share_header">
        {social.copyLinkHeader}
      </BodyText>
      <CaptionText className="text-center social_share_subheader">
        {social.subheader}
      </CaptionText>
      <SocialShare
        shareUrl={`https://paypal.com/donate?cmd=_s-xclick&hosted_button_id=${hostedButtonId}&source=url`}
        socialCampaign={socialCampaign}
        isMobile={TemplateData.ismobile}
        analytics={handleSocialAnalytics}
      />
    </>
  );
}
